export function formatPhoneDisplay(phone: string): string {
  const d = phone.replace(/\D/g, "");
  if (d.length >= 12 && d.startsWith("55")) {
    return `+${d.slice(0, 2)} (${d.slice(2, 4)}) ${d.slice(4, 9)}-${d.slice(9)}`;
  }
  return phone.startsWith("+") ? phone : `+${d}`;
}

export function getContactInitials(
  displayName: string | null | undefined,
  phone: string,
): string {
  const name = displayName?.trim();
  if (name) {
    const parts = name.split(/\s+/).filter(Boolean);
    if (parts.length >= 2) {
      return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
    }
    return name.slice(0, 2).toUpperCase();
  }
  const digits = phone.replace(/\D/g, "").slice(-2);
  return digits || "??";
}

export function formatThreadTime(iso: string, locale: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) {
    return "";
  }
  const now = new Date();
  const sameDay =
    date.getDate() === now.getDate() &&
    date.getMonth() === now.getMonth() &&
    date.getFullYear() === now.getFullYear();
  if (sameDay) {
    return date.toLocaleTimeString(locale, {
      hour: "2-digit",
      minute: "2-digit",
    });
  }
  const weekAgo = now.getTime() - 7 * 24 * 60 * 60 * 1000;
  if (date.getTime() > weekAgo) {
    return date.toLocaleDateString(locale, { weekday: "short" });
  }
  return date.toLocaleDateString(locale, {
    day: "2-digit",
    month: "2-digit",
  });
}

export function formatMessageTime(iso: string, locale: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) {
    return "";
  }
  return date.toLocaleString(locale, {
    day: "2-digit",
    month: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function sourceLabel(
  source: string | undefined,
  translate: (key: string) => string,
): string {
  switch (source) {
    case "lead":
      return translate("partnerWhatsappInbox.source.lead");
    case "bot":
      return translate("partnerWhatsappInbox.source.bot");
    case "template":
      return translate("partnerWhatsappInbox.source.template");
    case "system":
      return translate("partnerWhatsappInbox.source.system");
    default:
      return source ?? "";
  }
}
